import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import getSiteNextBillingRun, {
  NextBillingRunResponse,
} from "../http/getSiteNextBillingRun";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useSiteNextBillingRun = (
  siteId: string,
  enabled = true
): UseQueryResult<NextBillingRunResponse, unknown> => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);
  return useQuery(
    ["site", siteId, "next-billing-run"],
    async () =>
      getSiteNextBillingRun(
        await getAuthTokenBlocking(getToken, relogin),
        siteId
      ),
    {
      enabled: enabled && !!siteId,
      // The next-run date only changes day-to-day; no need to poll.
      staleTime: 60 * 60 * 1000,
    }
  );
};

export default useSiteNextBillingRun;
